import "./AdminOrders.css";

import ModalBase from "../../../../modals/ModalBase";
import { Order } from "../../../../model/model";
import React from "react";
import { api } from "../../../../api/api";
import { useModal } from "../../../../context/ModalContext";

export default function AdminOrders() {
  const [orders, setOrders] = React.useState<Order[]>([]);
  const { showModal, hideModal } = useModal();

  React.useEffect(() => {
    api.admin.orders.getOrders().then((res) => {
      setOrders(res || []);
    });
  }, []);

  const onViewOrder = (order: Order) => {
    const json = JSON.stringify(order, null, 2);
    showModal(
      <ModalBase
        header="Order"
        body={<pre style={{ width: "100%" }}>{json}</pre>}
        footer={
          <>
            <div />
            <button className="loa-button" onClick={hideModal}>
              Close
            </button>
          </>
        }
      />
    );
  };

  return (
    <div className="admin-orders">
      {orders.map((order, index) => (
        <div key={index} className="admin-order">
          <button
            className="loa-link-button"
            onClick={() => onViewOrder(order)}
          >
            {order.orderId}
          </button>
          <div>{order.acceptedOn}</div>
          <div>
            {order.purchasedItems.map((item) => (
              <div>{item.productName}</div>
            ))}
          </div>
          <div>{order.customerInfo.fullName}</div>
          <div>{order.customerInfo.email}</div>
          <div>{order.customerPaid.string}</div>
          <div>{order.comment}</div>
        </div>
      ))}
      {orders.length === 0 && <p>No orders found</p>}
    </div>
  );
}
